export const settingsSpecification = {
  title: '설정',
  purpose: '운영에 공통 적용되는 등급, 난이도, 카테고리, 무료 회원 이용 정책을 관리합니다.',
  functions: [
    '난이도 표시명과 악보 카테고리, 정렬 순서를 수정합니다.',
    '등급별 드럼·인지 권한과 전체 악보의 무료 회원 이용 난이도를 설정합니다.',
  ],
  connections: [
    '악보관리는 난이도명·카테고리·무료 회원 이용 정책을 사용합니다.',
    '회원관리와 구독관리는 등급명 및 권한 설정을 참조합니다.',
  ],
  app: '여기서 정한 등급·권한·무료 이용 정책은 사용자 앱의 메뉴 접근과 콘텐츠 이용 범위에 공통 반영됩니다.',
}

export const settingsDataModelGuide = [
  '설정 키: setting_key 또는 정책 테이블 ID',
  '관리 대상: grade_code 권한, difficulty_code 표시명, 카테고리 순서, 무료 회원 이용 기본 정책',
  '설정 변경은 악보관리·회원관리·구독관리의 참조 값을 갱신합니다.',
]

export const settingsImplementationGuide = [
  '화면 식별자: settings. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 등급명, 난이도명, 카테고리명과 순서, 등급별 권한, 무료 회원 이용 난이도.',
  '각 설정 항목은 수정 버튼을 눌러 모달에서 변경하고 저장 전 값과 영향 범위를 확인합니다.',
  '카테고리 삭제 시 연결된 곡을 미공개 처리하며 순서 변경은 사용자 앱 목록 순서에 반영합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]
